import { render } from "./MatchdayHome.vue?vue&type=template&id=f5440e6a&scoped=true"
import script from "./MatchdayHome.vue?vue&type=script&lang=js"
export * from "./MatchdayHome.vue?vue&type=script&lang=js"

import "./MatchdayHome.vue?vue&type=style&index=0&id=f5440e6a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5440e6a"]])

export default __exports__